module.exports = __webpack_public_path__ + "img/charging-hub-in-progress-proprietary.35f114ae.png";